export default function Footer() {
    return (
        <footer>
            <h1>
                &copy; 2024&nbsp;
                <a href="https://www.linkedin.com/in/devanshdalmia1/" rel="noreferrer" target={"_blank"}>
                    Devansh Dalmia
                </a>
                &nbsp;| All Rights Reserved
            </h1>
        </footer>
    );
}
